import * as PopoverPrimitive from "@radix-ui/react-popover";
import type { ComponentPropsWithoutRef, ComponentRef, Ref } from "react";

import { cn } from "@/lib/utils";

export const Popover = PopoverPrimitive.Root;
export const PopoverTrigger = PopoverPrimitive.Trigger;

type PopoverContentProps = ComponentPropsWithoutRef<typeof PopoverPrimitive.Content> & {
  ref?: Ref<ComponentRef<typeof PopoverPrimitive.Content>>;
};

export function PopoverContent({
  className,
  align = "center",
  sideOffset = 6,
  ref,
  ...props
}: PopoverContentProps) {
  return (
    <PopoverPrimitive.Portal>
      <PopoverPrimitive.Content
        ref={ref}
        align={align}
        sideOffset={sideOffset}
        className={cn(
          // Same opaque surface as ui/dialog.tsx and the app-shell user
          // menu — `bg-card` + `text-card-foreground` are the project's
          // canonical popover surface (the shadcn-default `bg-popover`
          // token isn't wired up in tailwind.config.ts).
          "z-50 w-72 rounded-md border border-border bg-card p-3 text-card-foreground shadow-lg outline-none",
          "data-[state=open]:animate-in data-[state=closed]:animate-out",
          "data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
          "data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95",
          className,
        )}
        {...props}
      />
    </PopoverPrimitive.Portal>
  );
}
